import { DEPOSIT_ROOT } from '@mobi/account/Areas/Deposit/Utils/routes'
import { routes as depositLimitRoutes } from '@mobi/account/Areas/DepositLimit/Utils/routes'
import { SIGNUP_ROOT_ROUTE } from '@mobi/account/Areas/SignUp/Utils'
import { ACTIVITY_STATEMENTS_ROUTE } from '@mobi/account/Areas/Statements/Utils/constants'
import { routes as accountRoutes } from '@mobi/account/Utils'
import { SHORTENED_URL_ROUTE } from '@core/Areas/ShortenedUrls/constants'
import { TAKE_A_BREAK_ROUTE } from './Areas/Account/TakeABreak/constants'
import { ACCOUNT_ACTIVITY_ROUTE } from './Areas/AccountActivity/constants'
import { BankAccountEditRoute } from './Areas/BankAccount/constants'
import { CHANGE_TEMP_PASSWORD_ROUTE } from './Areas/ChangePassword/constants'
import { KAMBI_ROOT_ROUTE } from './Areas/KambiClient/constants'
import { TABLocatorWebRoute } from './Areas/TABLocatorWeb/constants'

type RoutePath = `/${string}`
type AppRoutesPath = Readonly<RoutePath | RoutePath[]>

export const AppRoutes = {
  Account: '/account',
  AccountActivity: [`/${ACCOUNT_ACTIVITY_ROUTE}/:tab`, `/${ACCOUNT_ACTIVITY_ROUTE}`],
  AccountLogout: '/account/logout',
  BankAccountEdit: `/${BankAccountEditRoute}`,
  Biometrics: '/account/biometrics',
  Blackbook: '/account/blackbook',
  BlockDebitCard: accountRoutes.blockDebitCard,
  ChangePassword: '/account/change-password',
  ChangeTemporaryPassword: `/${CHANGE_TEMP_PASSWORD_ROUTE}/:accountNumber`,
  CloseAccount: '/account/close',
  ContactUs: '/contactus',
  Deposit: DEPOSIT_ROOT,
  DepositLimits: depositLimitRoutes.editDepositLimit,
  FavouriteNumbers: '/favourite-numbers',
  BetLoop: '/bet-loop',
  BetLoopProfile: '/bet-loop/profile',
  BetLoopMyProfile: '/bet-loop/my-profile',
  BetLoopMyProfileFollowList: '/bet-loop/my-profile/follow-list',
  BetLoopSearchProfiles: '/bet-loop/search',
  GoodThings: '/goodthings',
  Home: '/',
  Jackpots: '/jackpots',
  MarketingCommunications: '/account/marketingcommunications',
  MarketingCommunicationsOptIn: '/account/marketingcommunications/optin',
  Meetings: '/tote',
  MysteryBet: ['/tote/mystery', '/tote/mystery/:meetingId/:raceNumber'],
  NextEvents: ['/next-events', '/tote/nextevents'],
  Offers: '/account/offer',
  Precommitment: `/account/precommitment`,
  RaceCard: '/tote/meetings/:meetingId/:raceNumber',
  RaceCardFixedOnly: '/fobracing/propositions/:product/:code/:raceId/:selectiondate?',
  RaceCardSky: '/live-sky-race',
  RaceEvents: '/fobracing/:product/:code/:date?',
  RaceList: ['/tote/meetings/:meetingId', '/tote/races'],
  Search: '/search',
  Settings: '/account/settings',
  SettingsMFA: '/account/settings/mfa',
  SignUp: `/${SIGNUP_ROOT_ROUTE}`,
  Specials: '/specials',
  /** Kambi Sports Offering Integration */
  Sports: '/sports',
  SportsRoot: `/${KAMBI_ROOT_ROUTE}`,
  Statements: `/${ACTIVITY_STATEMENTS_ROUTE}`,
  StructuredSearch: '/smart-form',
  ShortenedUrls: `/${SHORTENED_URL_ROUTE}`,
  TABLocatorWeb: `/${TABLocatorWebRoute}`,
  TakeABreak: `/${TAKE_A_BREAK_ROUTE}`,
  Tipping: '/totesports',
  Toolbox: '/toolbox',
  VenueMode: '/venue-mode',
} as const

export const RACES_ROUTES: AppRoutesPath[] = [
  AppRoutes.AccountActivity,
  AppRoutes.Blackbook,
  AppRoutes.RaceCardFixedOnly,
  AppRoutes.FavouriteNumbers,
  AppRoutes.Jackpots,
  AppRoutes.Meetings,
  AppRoutes.MysteryBet,
  AppRoutes.NextEvents,
  AppRoutes.Offers,
  AppRoutes.RaceEvents,
  AppRoutes.RaceList,
  AppRoutes.Specials,
  AppRoutes.StructuredSearch,
  AppRoutes.Tipping,
  // Non-react route
  '/goodthings',
]
